
{#if failed}
<div class="box">
  Your browser settings are preventing the Facebook timeline of {name} to be shown.
  Open their <a href="https://www.facebook.com/{handle}">timeline on Facebook</a>.
</div>
{:else}

<div style="display: flex;
flex-flow: column;height:100%;" bind:clientHeight={height}>
{#if readyToLoad}
<iframe title="facebook" srcdoc={iframeHtml} style="height:100%;"/>
{/if}
</div>

{/if}

<script>
  export let name, handle;

  import { onMount } from "svelte";

  let height;

  const scriptTag = 'script';

  $: timelineTag = `<div class="fb-page" data-href="https://www.facebook.com/${handle}"` +
  `data-show-posts="true" data-width="" data-height=${height} data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="false" data-hide-cta="true"></div>`;

  $: iframeHtml =  '<!doctype html><html lang="en"><body>' + 
    `<div id="fb-root"></div><${scriptTag} async defer crossorigin="anonymous" src="https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v17.0"  nonce="qYwkyiBe"></${scriptTag}>${timelineTag}` +
    '</body>';
  
  let readyToLoad = false;

  onMount(() => {
    readyToLoad = true;
    retry();
  });

  let failed;

  let retries = 0;

  function retry() {
      if (!window.FB) {
        retries++;
        if(retries == 2) {
          failed = true;
        }
        else {
          setTimeout(retry, 1000);
        }
      }
  }
</script>
